<template>
  <qc-container title="实体店详情" v-if="detail" show-return show-divider>
    <div class="title">实体店信息</div>
    <div class="flex">
      <image-show :images="[filePath+detail.logo]" :width="300" :height="150"></image-show>
      <div class="flex-1">
        <el-descriptions :column="2" border >
          <el-descriptions-item label-class-name="w150" label="门店名称">{{detail.storeName}}</el-descriptions-item>
          <el-descriptions-item label-class-name="w150" label="门店电话">{{detail.storePhone}}</el-descriptions-item>
          <el-descriptions-item label-class-name="w150" label="营业时间">{{detail.businessTime}}</el-descriptions-item>
          <el-descriptions-item label-class-name="w150" label="门店地址">{{detail.address}}</el-descriptions-item>
        </el-descriptions>
      </div>
    </div>

    <el-descriptions class="mt10" title="门店资质" :column="2" border >
      <el-descriptions-item label-class-name="w150" label="公司名称">{{detail.name}}</el-descriptions-item>
      <el-descriptions-item label-class-name="w150" label="住所">{{detail.shopQualifications.address}}</el-descriptions-item>
      <el-descriptions-item label-class-name="w150" label="信用代码">{{detail.shopQualifications.creditCode}}</el-descriptions-item>
      <el-descriptions-item label-class-name="w150" label="有效期">{{detail.shopQualifications.expireDate}}</el-descriptions-item>
      <el-descriptions-item label-class-name="w150" label="营业执照">
        <image-show :images="[filePath+detail.shopQualifications.businessLicense]" :width="300" :height="150"></image-show>
      </el-descriptions-item>
      <el-descriptions-item label-class-name="w150" label="开户许可证">
        <image-show :images="[filePath+detail.shopQualifications.openPermit]" :width="300" :height="150"></image-show>
      </el-descriptions-item>

    </el-descriptions>
    <el-descriptions class="mt10" title="法人信息" :column="2" border >
      <el-descriptions-item label-class-name="w150" label="法人">{{detail.shopQualifications.legalPerson}}</el-descriptions-item>
      <el-descriptions-item label-class-name="w150" label="身份证号">{{detail.shopQualifications.identity}}</el-descriptions-item>
      <el-descriptions-item label-class-name="w150" label="联系人">{{detail.shopQualifications.concatName}}</el-descriptions-item>
      <el-descriptions-item label-class-name="w150" label="联系号码">{{detail.shopQualifications.mobile}}</el-descriptions-item>
      <el-descriptions-item label-class-name="w150" label="身份证正面">
        <image-show :images="[filePath+detail.shopQualifications.identityLeft]" :width="300" :height="150"></image-show>
      </el-descriptions-item>
      <el-descriptions-item label-class-name="w150" label="身份证反面">
        <image-show :images="[filePath+detail.shopQualifications.identityRight]" :width="300" :height="150"></image-show>
      </el-descriptions-item>
    </el-descriptions>
  </qc-container>

  <qc-container class="mt20" v-if="detail" :tab-list="['商品管理','订单管理','财务流水','员工管理']" :active-index="activeIndex" @changeTab="changeTab">
    <store-goods-list v-if="activeIndex==0" :org-id="detail.id" ></store-goods-list>
    <order-list v-else-if="activeIndex==1" :shopType="1" :org-id="detail.id"></order-list>
    <org-finance-list v-else-if="activeIndex==2" :org-id="detail.id" :show-deposit-money="true"></org-finance-list>
    <person-list v-else-if="activeIndex==3" :org-id="detail.id"></person-list>
  </qc-container>
  <return-box></return-box>
</template>

<script>

import QcContainer from "@/components/el/layout/qc-container.vue";
import UserBox from "@view/components/user-box.vue";
import ImageShow from "@/components/base/image-show.vue";
import ReturnBox from "@/components/home/return-box.vue";
import OrgFinanceList from "@org/finance/list.vue";
import storeGoodsList from "@view/store/op/store-goods-list.vue";
import OrderList from "@view/components/order/order-list.vue";
import PersonList from "@view/store/op/person-list.vue";

export default {
  name: "franchisee-detail",
  components: {PersonList, OrderList, storeGoodsList, OrgFinanceList,   ReturnBox, ImageShow, UserBox, QcContainer},
  data() {
    return {
      detail:null,
      activeIndex:0,
    }
  },
  mixins: [tableBase],
  methods: {
    changeTab(index){
      this.activeIndex = index;
    }
  },
  mounted() {
    this.simplePost("/api/mgr/business/shop/getShopDetail",{id:this.$route.query.id},result=>{
      this.detail = result.data;
    })
  }
}
</script>


<style lang="less" scoped>
.title{
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
}
</style>
